import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Renewal Reminders</h3>
                <p className="text-sm text-gray-600">
                    Never miss a registration, insurance, or permit renewal.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Types of Renewals</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Registration:</strong> Vehicle license and tag renewals.</li>
                    <li><strong>Insurance:</strong> Policy expiration and premium due dates.</li>
                    <li><strong>Inspection:</strong> Mandatory safety or emissions inspections.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Alert Status</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Upcoming:</strong> Renewals that are due in the near future.</li>
                    <li><strong>Overdue:</strong> Renewals that have passed their deadline.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Reports and Search</h4>
                <p className="text-sm text-gray-600">
                    Search for specific vehicles or date ranges to see what documents need attention. Export the list to <strong>PDF</strong> or <strong>CSV</strong> for compliance auditing.
                </p>
            </section>
        </div>
    );
};

export default Help;
